import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class NewsSlider {
	constructor($el) {
		this.$el = $el;
        this.$wrapper = this.$el.parent();

		this.options = {
			autoPlay: true,
			pageDots: true,
			wrapAround: false,
			prevNextButtons: false,
			freeScroll: false,
			cellSelector: ".news-list__item",
            cellAlign: "left",
            fade: true
		};

		if (this.$el.length) {
			this._init();
            this._bindEvents();
		}
	}

    _init() {
        this.$slides = this.$el.find('.news-list__item');
        this.slidesCount = this.$slides.length;
        this.slider = new Flickity(this.$el[0], this.options);
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }


    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

	_onBreakpointChange() {
        this.slider = new Flickity(this.$el[0], this.options);
    }
}

export default NewsSlider;
